// extracted by mini-css-extract-plugin
export default {"toggleBase":"ButtonToggle_toggleBase__Ja+yL","leftButton":"ButtonToggle_leftButton__cd7dT","rightButton":"ButtonToggle_rightButton__aOuNl","selected":"ButtonToggle_selected__HpTY-"};